import { PhoneCall, Phone, X } from "lucide-react";
import { useState } from "react";

import { api } from "@/api";
import { formatError } from "@/auth";
import { Arrow, Check } from "@/components/landing/icons";

export function MobileBar({ source }) {
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState("");
  const [state, setState] = useState({ busy: false, done: false, error: "" });
  const send = async (e) => {
    e.preventDefault();
    setState({ busy: true, done: false, error: "" });
    try { await api.post("/public/callback", { phone, source: `${source}-rappel` }); setState({ busy: false, done: true, error: "" }); } catch (err) { setState({ busy: false, done: false, error: formatError(err.response?.data?.detail) }); }
  };
  const close = () => { setOpen(false); if (state.done) { setState({ busy: false, done: false, error: "" }); setPhone(""); } };
  return (
    <div className="lp-mbar" data-testid="mobile-cta-bar">
      {open && (
        <div className="lp-mcb" data-testid="callback-panel">
          <button type="button" className="lp-mcbx" onClick={close} aria-label="Fermer" data-testid="callback-close"><X size={16} /></button>
          {state.done ? (
            <p className="lp-mcbdone" data-testid="callback-success"><Check />C'est noté ! Un conseiller vous rappelle très vite.</p>
          ) : (
            <form onSubmit={send} data-testid="callback-form">
              <strong>Être rappelé gratuitement</strong>
              <div className="lp-mcbrow">
                <input type="tel" inputMode="tel" autoComplete="tel" placeholder="Votre numéro" value={phone} onChange={(e) => setPhone(e.target.value)} required autoFocus data-testid="callback-phone" />
                <button type="submit" className="lp-btn lp-sm" disabled={state.busy} data-testid="callback-submit">{state.busy ? "Envoi…" : "Envoyer"}</button>
              </div>
              {state.error && <p className="lp-error" data-testid="callback-error">{state.error}</p>}
            </form>
          )}
        </div>
      )}
      <a href="tel:+33255997758" className="lp-mcall" aria-label="Appeler le 02 55 99 77 58" data-testid="mobile-call-btn"><Phone size={18} /></a>
      <button type="button" className="lp-mback" onClick={() => (open ? close() : setOpen(true))} data-testid="mobile-callback-btn"><PhoneCall size={16} />Être rappelé</button>
      <a href="#etude" className="lp-btn" data-testid="mobile-study-btn">Étude gratuite<span className="lp-ico"><Arrow /></span></a>
    </div>
  );
}
